import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import axiosw from 'axios'


let getDashboardPageDate = (district) => {
    const requestData = {
        ...district,
        academicyear: localStorage.getItem("academicyear")
    };
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'dashboard/getdashboardpagedata', requestData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}


let getDashboardPageDatePdf = (districtId, tokenD) => {

    console.log(districtId, tokenD);

    let dashboardPdfObj = {
        headers: {
            'Content-Type': 'application/json',
            'authorization': tokenD
        }
    }

    return new Promise((resolve, reject) => {
        axiosw.post(config.basePath + 'dashboard/getdashboardpagedata', { districtId: districtId }, dashboardPdfObj).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

let addDashboardUser = (formData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'dashboard/adddashboarduser', formData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}


let editDashboardUser = (formData, distId, oldEmail) => {
    console.log(formData);
    const reqObj = {
        'oldemail': oldEmail,
        'newemail': formData.email,
        'firstname': formData.firstname,
        'lastname': formData.lastname,
        'accesslevel': formData.accesslevel,
        'schoolId': formData.schoolId,
        'districtId': distId
    }
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'dashboard/editdashboarduser', reqObj).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}


let deletedashboarduser = (reqObj) => {
    // let { email, accesslevel, schoolId, districtId } = req.body;
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'dashboard/deletedashboarduser', reqObj).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

const dashboardService = {
    getDashboardPageDate,
    addDashboardUser,
    editDashboardUser,
    deletedashboarduser,
    getDashboardPageDatePdf
}

export default dashboardService 